const SIDEBAR_NAV_WIDTHS = ['60%', '45%', '55%', '40%', '50%'];

export const SidebarDesktopSkeleton = () => {
  return (
    <aside className='lg:w-64 pt-3 pb-4 pl-6 pr-4 flex flex-col justify-between overflow-x-hidden sm:bg-secondary'>
      <nav className='flex flex-col place-items-start gap-y-3 xs:flex-1 overflow-y-auto overflow-x-hidden animate-pulse'>
        {SIDEBAR_NAV_WIDTHS.map((width) => (
          <div key={width} className='flex items-center w-full p-3 gap-3'>
            <div className='w-6 h-6 bg-tertiary rounded-sm shrink-0' />
            <div className='h-4 bg-tertiary rounded-sm' style={{ width }} />
          </div>
        ))}
      </nav>
      <div className='xs:hidden w-full h-px bg-tertiary my-6' />
      <div className='flex-col mb-10 animate-pulse'>
        <div className='flex shrink-0 p-3 items-center rounded-sm w-full gap-3'>
          <div className='w-8 h-8 bg-tertiary rounded-sm shrink-0' />
          <div className='h-4 bg-tertiary rounded-sm w-24' />
        </div>
        <div className='flex shrink-0 gap-3 p-3 items-center rounded-sm w-full mt-2'>
          <div className='w-8 h-8 bg-tertiary rounded-full shrink-0' />
          <div className='flex flex-col gap-1.5 flex-1'>
            <div className='h-4 bg-tertiary rounded-sm w-20' />
            <div className='h-3 bg-tertiary rounded-sm w-32' />
          </div>
        </div>
      </div>
      <div className='flex gap-4 px-3 items-center animate-pulse'>
        <div className='w-10 h-5 bg-tertiary rounded-full' />
        <div className='w-8 h-8 bg-tertiary rounded-full' />
        <div className='w-6 h-6 bg-tertiary rounded-sm ml-auto' />
      </div>
    </aside>
  );
};
